<template>
  <div class="content">
    <div class="MB-20">
      <div class="content-item">
        <div class="content-item__title flex-row-between">
          <div class="content-item__title-left flex-row-start">
            <el-select v-model="city" class="MR-20" placeholder="城市" @change="getContentData" size="small">
              <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <el-select v-model="dataType" class="MR-20" placeholder="参数类型" @change="changeDataType" size="small">
              <el-option v-for="item in dataTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <el-select v-model="timeType" class="MR-20" placeholder="每日数据" @change="refreshPageDate" size="small">
              <el-option v-for="item in timeTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <el-date-picker v-model="date" :type="pickerDateType" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
              :clearable="false" @change="getContentData" @focus="timeRegion = '0'" size="small"></el-date-picker>

          </div>
          <div class="content-item__title-right text-14 pointer text-blue" @click="downloadExcel">下载报表</div>
        </div>
        <div class="flex-row-between">
          <div class="content-item_info content-item__echarts" ref="echartspie1"></div>
          <div class="content-item_info content-item__echarts" ref="echartspie2"></div>
          <div class="content-item_info content-item__echarts" ref="echartspie3"></div>
        </div>
        <div class="content-item_info flex-row-start text-16 MB-20" v-if="totalDataSet.length">
          <div class="content-item__info-item flex-w__1 text-center">
            <p style="opacity:0;">0</p>
            <div class="text-18 text-bold MT-20">总计</div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>求租</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[0].value || 0 }}
              <span :class="parseFloat(totalDataSet[0].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[0].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>求购</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[1].value || 0 }}
              <span :class="parseFloat(totalDataSet[1].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[1].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>出租</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[2].value || 0 }}
              <span :class="parseFloat(totalDataSet[2].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[2].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>出售</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[3].value || 0 }}
              <span :class="parseFloat(totalDataSet[3].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[3].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>置顶发布</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[4].value || 0 }}
              <span :class="parseFloat(totalDataSet[4].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[4].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>常规发布</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[5].value || 0 }}
              <span :class="parseFloat(totalDataSet[5].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[5].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>楼盘区域呈现</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[6].value || 0 }}
              <span :class="parseFloat(totalDataSet[6].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[6].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
          <div class="content-item__info-item flex-w__1 text-center">
            <p>行政区域呈现</p>
            <div class="text-18 text-bold MT-20">
              {{ totalDataSet[7].value || 0 }}
              <span :class="parseFloat(totalDataSet[7].chainGrowthRatio || 0) > 0 ? 'text-red' : 'text-green'">({{
                totalDataSet[7].chainGrowthRatio | numSymbol }}%)</span>
            </div>
          </div>
        </div>
      </div>
      <el-table border :data="tableData" id="paramsTable" size="small" header-row-class-name="table-header">
        <el-table-column align="center" label="日期/月份" prop="dataTime"></el-table-column>
        <el-table-column align="center" label="求租" prop="askRentVolume"></el-table-column>
        <el-table-column align="center" label="求购" prop="askSellVolume"></el-table-column>
        <el-table-column align="center" label="出租" prop="rentVolume"></el-table-column>
        <el-table-column align="center" label="出售" prop="sellVolume"></el-table-column>
        <el-table-column align="center" label="置顶发布" prop="topReleaseVolume"></el-table-column>
        <el-table-column align="center" label="常规发布" prop="routineReleaseVolume"></el-table-column>
        <el-table-column align="center" label="楼盘区域呈现" prop="housesShowVolume"></el-table-column>
        <el-table-column align="center" label="行政区域呈现" prop="adminShowVolume"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
const start = new Date();
const end = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
const startTime = getYear(start);
const endTime = getYear(end);

/**
 * 返回格式化的时间
 * @param {Date} date 当前需要格式化的时间对象
 * @param {Strin} fmt 日期格式
 */
function getYear(date, isTime, onlyTime) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let time = year + "-" + get0(month) + "-" + get0(day);
  if (isTime) {
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (onlyTime) {
      time = get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    } else {
      time += " " + get0(hour) + ":" + get0(minutes) + ":" + get0(seconds);
    }
  }

  return time;
}
function get0(num) {
  return num < 10 ? "0" + num : num;
}

import Echarts from "echarts";
import FileSaver from "file-saver";
import XLSX from "xlsx";
// // 引入组件库全局样式资源
export default {
  filters: {
    // 数字添加符号
    numSymbol: msg => {
      if (msg) {
        const douleN = parseFloat(msg);
        if (!douleN.isNaN) {
          return douleN > 0 ? "+" + msg : msg;
        } else {
          return msg;
        }
      } else {
        return msg;
      }
    }
  },
  data() {
    return {
      dataSet: {},
      city: '00',
      cities: [
        {
          id: "00",
          name: "全部"
        }
      ],
      // 日数据和月数据
      timeType: "1",
      timeTypes: [
        {
          id: "1",
          name: "每日数据"
        },
        {
          id: "2",
          name: "每月数据"
        }
      ],
      // 日期范围类型 默认 近7天、近3个月
      timeRegion: '2',
      //
      dataType: '1',
      dataTypes: [
        {
          id: "1",
          name: "发布参数"
        },
      ],
      date: [startTime, endTime],
      // 时间选择器类型
      pickerDateType: 'daterange',
      // 时间选择器配置
      pickerOptions: {},
      // 总计数据
      totalDataSet: [],
      tableData: [
        {
          dataTime: "2022-02-11",
          askRentVolume: 2000,
          askSellVolume: 3000,
          rentVolume: 3000,
          sellVolume: 2000,
          topReleaseVolume: 3000,
          routineReleaseVolume: 3000,
          housesShowVolume: 3000,
          adminShowVolume: 3000,
        }
      ]
    };
  },
  computed: {
    /**
     * 返回当前数据获取类型
     */
    getTimeType() {
      if (this.date[0] && this.date[0] === this.date[1]) {
        return "hour";
      }
      return "day";
    }
    //    getmonth () {
    //         return this.month
    //     }
  },
  created() {
    // console.log('params-statistic creat');
    // 日期初始化
    this.dateTypeSelet(this.timeType);
    this.date = [startTime, endTime];
  },
  mounted() {
    // 初始化
    this.initEcharts();
    const Loading = this.$loading();
    Promise.all([
      this.getContentData(false),
      this.getCityList(false),
    ]).finally(() => {
      Loading.close();
    });
  },
  beforeDestroy() {
    if (this.destoryFn && Object.prototype.toString.call(this.destoryFn) === '[object Array]') {
      this.destoryFn.forEach(fn => {
        window.removeEventListener('resize', fn);
      })
    }
  },
  methods: {
    /**
     * 下载报表
     */
    downloadExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#paramsTable"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "核心数据-参数统计.xlsx"
        );
      } catch (e) {
        this.$message.error("文件下载失败");
      }
      return wbout;
    },
    /**
     * 刷新头部数据、折线图、和表格数据
     */
    refreshPageDate() {
      const Loading = this.$loading();
      this.dateTypeSelet(this.timeType)
      if( this.timeType == '1' ) {
        this.pickerDateType = 'daterange'
        this.date = [startTime, endTime]
      } else {
        this.pickerDateType = 'monthrange'
        const start = new Date();
        const end = new Date();
        start.setMonth(start.getMonth() - 3);
        end.setMonth(end.getMonth() - 1);
        this.date = [start, end]
      }
      Promise.all([
        this.getContentData(false),
      ]).finally(() => {
        Loading.close();
      });
    },
    /**
     * 数据类型切换
     */
    changeDataType() {
      this.updateEcharts();
    },
    // 初始化图表
    initEcharts() {
      this.pubTypeChart = Echarts.init(this.$refs.echartspie1);
      this.pubModelChart = Echarts.init(this.$refs.echartspie2);
      this.showModelChart = Echarts.init(this.$refs.echartspie3);
      // console.log('echarts init');
      window.addEventListener("resize", this.pubTypeChart.resize);
      window.addEventListener("resize", this.pubModelChart.resize);
      window.addEventListener("resize", this.showModelChart.resize);
      // 销毁时的函数列表
      this.destoryFn = [this.pubTypeChart.resize, this.pubModelChart.resize, this.showModelChart.resize]
      this.showWeekPickerBox = false;
    },
    // 更新图表数据
    updateEcharts(echartsDataList) {
      if(!this.pubTypeChart || !this.pubModelChart || !this.showModelChart) return;
      let optionCommon = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'left'
        },
      };
      // let emptyTitle = {
      //     text: '暂无数据信息',
      //     left: 'center',
      //     top: "center",
      //     textStyle: {
      //       color: "pink",
      //       fontSize: 16,
      //       fontWeight: 400
      //     }
      // };
      this.pubTypeChart.setOption({
        title: {
          text: '发布类型',
          left: 'center',
        },
        ...optionCommon,
        series: [
          {
            type: 'pie',
            radius: '70%',
            data: [
              { value: echartsDataList[0], name: '求租' },
              { value: echartsDataList[1], name: '求购' },
              { value: echartsDataList[2], name: '出租' },
              { value: echartsDataList[3], name: '出售' },
            ],
            label: {
              position: 'inner',
              formatter: '{b}: {d}%'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
      this.pubModelChart.setOption({
        title: {
          text: '发布方式',
          left: 'center',
        },
        ...optionCommon,
        series: [
          {
            type: 'pie',
            radius: '70%',
            data: [
              { value: echartsDataList[4], name: '置顶发布' },
              { value: echartsDataList[5], name: '常规发布' },
            ],
            label: {
              position: 'inner',
              formatter: '{b}: {d}%'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
      this.showModelChart.setOption({
        title: {
          text: '呈现方式',
          left: 'center',
        },
        ...optionCommon,
        series: [
          {
            type: 'pie',
            radius: '70%',
            data: [
              { value: echartsDataList[6], name: '楼盘区域呈现' },
              { value: echartsDataList[7], name: '行政区域呈现' },
            ],
            label: {
              position: 'inner',
              formatter: '{b}: {d}%'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
    /**
     * 更新echarts
     */
    /**
     * 接口时间参数适配
     */
    normalDate(startDate, endDate) {
      // console.log('normal ', startDate, endDate)
      let start
      let end
      switch (this.timeType) {
        case "1":
          // 按日
          start = startDate ? new Date(startDate + "T00:00:00.000+0800") : "";
          end = endDate ? new Date(new Date(endDate + "T23:59:59.999+0800").setDate(new Date(endDate + "T23:59:59.999+0800").getDate() - 1)) : "";
          start = getYear(start, false, false);
          end = getYear(end, false, false);
          break;
        default:
          // 按月
          start = startDate ? new Date(startDate) : "";
          end = endDate ? new Date(endDate) : "";
          start = start.getFullYear() + "-" + get0(start.getMonth() + 1);
          end = end.getFullYear() + "-" + get0(end.getMonth() + 1);
          break;
      }
      return [start, end];
    },
    /**
     * 生成指定日期之间的日期数组 ‘YYYY-MM-DD’
     */
    getDates(startDate, endDate) {
      const dates = [];
      const start = new Date(startDate);
      const end = new Date(endDate);
      for (let date = start; date <= end; date.setDate(date.getDate() + 1)) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formattedDate = `${year}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        dates.push(formattedDate);
      }
      return dates;
    },
    /**
     * 生成指定月份之间的月份数组 ‘YYYY-MM’
     */
    getMonthList(startDateStr, endDateStr) {
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);
      const yearDiff = endDate.getFullYear() - startDate.getFullYear();
      const monthDiff = endDate.getMonth() - startDate.getMonth();
      const totalMonthDiff = yearDiff * 12 + monthDiff + 1; // 总月份差
      const monthList = [];

      for (let i = 0; i < totalMonthDiff; i++) {
        const currentDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth() + i,
          1
        );
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const monthStr = month < 10 ? `0${month}` : month;
        monthList.push(`${year}-${monthStr}`);
      }
      return monthList;
    },
    /**
     * 获取表格数据
     */
    getTableData() {
      this.tableData = [];
      let dateList;
      let [startData, endData] = this.normalDate(this.date[0], this.date[1])
      // 生成表格日期范围数组
      if (this.timeType === "1") {
        // 按日
        dateList = this.getDates(startData, endData);
      } else {
        // 按月
        dateList = this.getMonthList(startData, endData);
        // console.log('monthList', dateList);
      }
      let echartsDataList = new Array(8).fill(0);
      dateList.forEach(dateItem => {
        const record = {
          dataTime: dateItem,
          askRentVolume: 0,
          askSellVolume: 0,
          rentVolume: 0,
          sellVolume: 0,
          topReleaseVolume: 0,
          routineReleaseVolume: 0,
          housesShowVolume: 0,
          adminShowVolume: 0,
        };
        for (let key in this.contentDatas) {
          if (this.contentDatas.hasOwnProperty(key)) {
            let data = this.contentDatas[key].find(
              item => item.name === dateItem
            );
            if (data) {
              switch (key) {
                case "1":
                  record["askRentVolume"] = data.value;
                  echartsDataList[0] += data.value
                  break;
                case "2":
                  record["askSellVolume"] = data.value;
                  echartsDataList[1] += data.value
                  break;
                case "3":
                  record["rentVolume"] = data.value;
                  echartsDataList[2] += data.value
                  break;
                case "4":
                  record["sellVolume"] = data.value;
                  echartsDataList[3] += data.value
                  break;
                case "5":
                  record["topReleaseVolume"] = data.value;
                  echartsDataList[4] += data.value
                  break;
                case "6":
                  record["routineReleaseVolume"] = data.value;
                  echartsDataList[5] += data.value
                  break;
                case "7":
                  record["housesShowVolume"] = data.value;
                  echartsDataList[6] += data.value
                  break;
                default:
                  record["adminShowVolume"] = data.value;
                  echartsDataList[7] += data.value
                  break;
              }
            }
          }
        }
        this.tableData.push(record);
      });
      this.tableData.reverse();
      this.updateEcharts(echartsDataList);
    },
    /**
     * 获取内容数据
     */
    getContentData(load = true) {
      let [startDate, endDate] = this.normalDate(this.date[0], this.date[1]);
      let cityName = this.cities.find((item) => item.id === this.city).name;
      return this.$ajax(
        "/web/communityClues/queryParamData",
        Object.assign(
          {
            type: this.dataType,
            dateType: this.timeType,
            dateRegion: this.timeRegion,
            startDate,
            endDate
          },
          this.city != "00" ? { cityId: this.city, cityName } : {},
        ),
        {
          method: "post",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          load
        }
      ).then(data => {
        // console.log("content", data.data);
        this.contentDatas = data.data.detailList;
        // this.curContentData = data.data.detailList[this.dataType];
        // 数据总计
        // 自生成测试数据
        // if( data.data.totalData && Object.prototype.toString.apply(data.data.totalData) == '[object Array]') {
        //   this.totalDataSet = [
        //     ...data.data.totalData.map(item => Object.freeze(item)),
        //   ]
        //   for( let i = data.data.totalData.length; i <= 8; i++ ) {
        //     this.totalDataSet.push(Object.freeze({type: i+'', value: '0', chainGrowthRatio: '0.0'}))
        //   }
        // }
        this.totalDataSet = [
          ...data.data.totalData.map(item => Object.freeze(item))
        ]
        // console.log('totalDataSet', this.totalDataSet)
        // 数据表格
        this.getTableData();
        return data.data;
      });
    },
    /**
     * 获取城市列表
     */
    getCityList(load = true) {
      return this.$ajax(
        "web/search_properties/city_name",
        {},
        {
          method: "get",
          load
        }
      ).then(data => {
        // console.log('城市列表', data.data);
        this.cities.push(
          // 让Vue不对其进行响应式初始化
          ...data.data.map(item => Object.freeze(item))
        );
        return data.data;
      });
    },
    // 时间日期面板
    dateTypeSelet(type) {
      let dateType = {
        '1': [
          {
            text: "一天内",
            onClick: picker => {
              this.timeRegion = "1";
              const start = new Date();
              picker.$emit("pick", [new Date(new Date().setDate(start.getDate() - 1)), start]);
            }
          },
          {
            text: "七天内",
            onClick: picker => {
              this.timeRegion = "2";
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "30天内",
            onClick: picker => {
              this.timeRegion = "3";
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "一年内",
            onClick: picker => {
              this.timeRegion = "4";
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        '2': [
          {
            text: "上个月",
            onClick: (picker) => {
              this.timeRegion = "1";
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "近3个月",
            onClick: (picker) => {
              this.timeRegion = "2";
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              end.setMonth(end.getMonth() - 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近12个月",
            onClick: (picker) => {
              this.timeRegion = "3";
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 12);
              end.setMonth(end.getMonth() - 1);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
      this.pickerOptions.shortcuts = dateType[type] || []
    },
  }
};
</script>
    
<style lang="scss" scoped>
.content-item {
  border: 1px solid #f4f5f9;

  .content-item__title {
    background: #f4f5f9;
    padding: 10px 20px;
  }

  .content-item_info {
    padding: 25px 0;
  }

  .content-item__echarts {
    height: 450px;
    flex: 1;
  }

  .content-item_summary {
    height: 100px;
  }
}

.flex-w__2 {
  flex: 2;
  width: 100%;
}

.weekPicker {
  height: 32px;
  border: 1px solid #dcdfe6;
  background-color: white;
  display: flex;
  align-items: center;
  line-height: 32px;
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
  padding-right: 10px;
}

.weekPickerBox {
  width: 360px;
  height: 150px;
  border: 1px solid #dcdfe6;
  background-color: white;
  position: absolute;
  top: 52px;
  left: 380px;
  z-index: 1000;
  display: flex;

  .leftBox {
    line-height: 28px;
    font-size: 14px;
    width: 90px;
    color: #606266;
    padding: 0 12px;
    text-align: left;
    border-right: 1px solid #dcdfe6;
  }

  .rightBox {
    width: 290px;

    .year {
      display: flex;
      margin-top: 10px;
      padding-right: 18px;
      padding-left: 18px;

      .yearmonth {
        font-size: 14px;
        margin: -4px 18px 0;
        text-align: center;
      }

      .shuangarrow {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }

      .arrow {
        margin-left: 22px;
        margin-right: 22px;
        width: 8px;
        height: 10px;
        cursor: pointer;
      }
    }

    .week {
      display: flex;
      flex-wrap: wrap;
      margin-left: 7px;
      margin-top: 10px;

      .activeWeek {
        cursor: pointer;
        line-height: 28px;
        font-size: 15px;
        color: #409eff;
        padding: 0 13px;
        width: 65px;
      }

      .weekArray {
        cursor: pointer;
        line-height: 28px;
        font-size: 15px;
        color: #606266;
        padding: 0 13px;
        width: 65px;
      }
    }
  }
}
</style>
    